import Vue from 'vue';
import api from '../bu/api';
import moment from 'moment';

export default {
	namespaced: true,

	state: () => ({
		offers: {},
		offersArray: [],
		offerStatMap: {},
		paging: null,
		offerOptions: [],
		yearlyUsageInfo: null
	}),

	getters: {
		yearlyUsageInfo: (state) => state.yearlyUsageInfo,
		offerOptions(state) {
			return state.offerOptions
		},
		offers(state) {
			return state.offersArray.sort((a, b) => {
				if (a.archived_at && b.archived_at) {
					return moment(a.archived_at).isBefore(moment(b.archived_at)) ? 1 : -1;
				}

				const isExpired = (offer) => {
					if (offer.start && offer.end) {
						const now = moment();
						const end = moment(offer.end).tz('GMT');
						return now.isAfter(end);
					} else {
						return false;
					}
				}

				a.isExpired = isExpired(a);
				b.isExpired = isExpired(b);

				if (a.isExpired && !b.isExpired) {
					return 1;
				} else if (!a.isExpired && b.isExpired) {
					return -1;
				}

				if (a.enabled !== b.enabled) {
					return b.enabled - a.enabled;
				}
				return b.id - a.id;
			});
		},
		offerMap(state) {
			return state.offers;
		},
		offerStatMap(state) {
			return state.offerStatMap;
		},
		paging(state) {
			return state.paging;
		},
	},

	actions: {
		async getYearlyOfferUsage({commit}) {
			const response = await api.getYearlyOfferUsage();
			commit('setYearlyOfferUsage', response.data);
		},
		async getOfferOptions({commit}) {
			const response = await api.getOfferOptions();
			commit('setOfferOptions', response.data);
		},
		async getAvailableOffers({commit}) { // offer is enabled and if has start and end, end is before now
			const response = await api.getAvailableOffers();
			commit('setOffers', response.data);
			return response.data.map((offer) => offer.id);
		},
		async getAllOffers({commit}) {
			const response = await api.getAllOffers();
			commit('setOffers', response.data);
			return response.data.map((offer) => offer.id);
		},
		async getOfferStat({commit}, id) {
			const response = await api.getOfferStat(id);
			commit('setOfferStat', {id, stat: response.data});
		},
		async getOffers({commit}, {page, type, keyword}) {
			const response = await api.getOffers(page, type, keyword);
			commit('setOffers', response.data.data);
			commit('setPaging', response.data);
			return response.data.data.map((offer) => offer.id);
		},
		async deleteOffer({commit}, offerId) {
			const response = await api.deleteOffer(offerId);
			commit('deleteOffer', offerId);
		},
		async saveOffer({commit}, { offer, photoFile }) {
			const response = await api.saveOffer(offer, photoFile);
			commit('setOffer', response.data);
			return response.data;
		}
	},

	mutations: {
		setYearlyOfferUsage(state, info) {
			state.yearlyUsageInfo = info;
		},
		setOfferOptions(state, options) {
			state.offerOptions = options;
		},
		setOfferStat(state, {id, stat}) {
			Vue.set(state.offerStatMap, id, stat);
		},
		setOffer(state, offer) {
			Vue.set(state.offers, offer.id, offer);
			Vue.set(state, 'offersArray', Object.values(state.offers));
		},
		setOffers(state, offers) {
			state.offers = {};
			offers.forEach((offer) => {
				Vue.set(state.offers, offer.id, offer);
			});
			Vue.set(state, 'offersArray', Object.values(state.offers));
		},
		setPaging(state, paging) {
			state.paging = paging;
		},
		deleteOffer(state, offerId) {
			Vue.delete(state.offers, offerId);
			Vue.set(state, 'offersArray', Object.values(state.offers));
		}
	},
}